module.exports = __webpack_public_path__ + "img/ic-payment-r-amazon-active.145850a7.svg";